var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 28.5C42.4853 28.5 44.5 26.4853 44.5 24C44.5 21.5147 42.4853 19.5 40 19.5C37.5147 19.5 35.5 21.5147 35.5 24C35.5 26.4853 37.5147 28.5 40 28.5Z",
    fill: "url(#paint0_linear_150_32988)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12.5C42.4853 12.5 44.5 10.4853 44.5 8C44.5 5.51472 42.4853 3.5 40 3.5C37.5147 3.5 35.5 5.51472 35.5 8C35.5 10.4853 37.5147 12.5 40 12.5Z",
    fill: "url(#paint1_linear_150_32988)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 44.5C42.4853 44.5 44.5 42.4853 44.5 40C44.5 37.5147 42.4853 35.5 40 35.5C37.5147 35.5 35.5 37.5147 35.5 40C35.5 42.4853 37.5147 44.5 40 44.5Z",
    fill: "url(#paint2_linear_150_32988)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28.5C10.4853 28.5 12.5 26.4853 12.5 24C12.5 21.5147 10.4853 19.5 8 19.5C5.51472 19.5 3.5 21.5147 3.5 24C3.5 26.4853 5.51472 28.5 8 28.5Z",
    fill: "url(#paint3_linear_150_32988)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38 25.5C38.82 25.5 39.5 24.82 39.5 24C39.5 23.18 38.82 22.5 38 22.5H23.5V14C23.5 10.84 24.84 9.5 28 9.5H38C38.82 9.5 39.5 8.82 39.5 8C39.5 7.18 38.82 6.5 38 6.5H28C23.16 6.5 20.5 9.16 20.5 14V22.5H10C9.18 22.5 8.5 23.18 8.5 24C8.5 24.82 9.18 25.5 10 25.5H20.5V34C20.5 38.84 23.16 41.5 28 41.5H38C38.82 41.5 39.5 40.82 39.5 40C39.5 39.18 38.82 38.5 38 38.5H28C24.84 38.5 23.5 37.16 23.5 34V25.5H38Z",
    fill: "url(#paint4_linear_150_32988)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_32988",
    x1: 29.6646,
    y1: 30.1285,
    x2: 47.7475,
    y2: 13.6764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_32988",
    x1: 29.6646,
    y1: 14.1285,
    x2: 47.7475,
    y2: -2.32363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_32988",
    x1: 29.6646,
    y1: 46.1285,
    x2: 47.7475,
    y2: 29.6764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_32988",
    x1: -2.33537,
    y1: 30.1285,
    x2: 15.7475,
    y2: 13.6764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_150_32988",
    x1: -11.5996,
    y1: 47.8331,
    x2: 57.4224,
    y2: -7.78765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.97c98def4eb97a5f5bcddb232824ada1.svg";
export { ForwardRef as ReactComponent };